module.exports = __webpack_public_path__ + "static/media/b7.a249ad0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lijunfeng/b7.mp3
// module id = O9Bf
// module chunks = 0